import { factory } from '@store/utils'

const specScoreKeys = [
  'cpuCinebench',
  'cpuPassmarkSingle',
  'generalScore',
  'gpuMark11',
]

export default {
  auto: '*',

  store: {
    getters: {
      specScoreKeys: () => specScoreKeys,
      specFactory: factory(() => ({
        isAbstract: false,
        label: null,
        laptopCount: null,
        laptopPriceMax: null,
        laptopPriceMedian: null,
        laptopPriceMin: null,
        specTypeId: null,
        usedCount: null,
        ...Object.fromEntries(specScoreKeys
          .map(scoreKey => [
            scoreKey,
            null,
          ])),
      })),
    },
  },
}
